
import GbAppButton from '../../../../components/AppButton/AppButton'
import GbArrowNavigation from '../../../../components/ArrowNavigation/ArrowNavigation.vue'

export default {
  name: 'EventCardLinkButton',
  components: { GbArrowNavigation, GbAppButton },
  props: {
    link: {
      type: String,
      required: true
    },

    isTooltip: {
      type: Boolean,
      required: true
    }
  }
}
